import { normalizePostMedia } from 'services/media';
import { extractSessionData, saveLoginInfo } from "./localStorage"; 
import { Client, PrivateKey as dhivePrivateKey } from '@hiveio/dhive';
import steem from '@steemit/steem-js';
import { PrivateKey, Signature, hash } from "@steemit/steem-js/lib/auth/ecc"; 
import { getSteemConfig } from "config";
import secureRandom from 'secure-random';
import { get_post } from "services/db-service";
import { createPermlink } from "services/dsteem-service";
import { getContent } from "services/posts-service"; 
const client = new Client(getSteemConfig()); 

const SPEEM_BENEFICIARY = parseFloat(process.env.SPEEM_BENEFICIARY) || 10;
const SPEEM_BENEFICIARY_ACCOUNT = (process.env.SPEEM_BENEFICIARY_ACCOUNT || "speem").trim().toLowerCase().replace("@", "");
export async function loginWithWif (user: string, password: string) {
  return new Promise(async (resolve) => { 
      let account;
      let isMasterKey = false;
      let accountExist = true;
      try {
          const accounts = await steem.api.getAccountsAsync([user]);
          if (accounts && accounts.length > 0) {
            account = (accounts[0]);
          } else {
            account = null;
          }
      } catch (error) {
          console.error('Error getting account:', error);
          account = null;
      }
      if (!account) {
          console.log('No account');
          accountExist = false;
          resolve({success:false, message:"Account does not exists."})
      }
      if (accountExist) {
        let postingpub = account.posting.key_auths[0][0];
        let activepub = account.active.key_auths[0][0];
        let ownerpub = account.owner.key_auths[0][0];
        let memopub = account.memo_key;
        let public_keys;
        let login_owner_pubkey;
        try {
            const private_key = PrivateKey.fromWif(password).toPublic().toString();
            // login_wif_owner_pubkey = private_key;
            public_keys = ({
                owner: private_key.toString(),
                posting: private_key.toString(),
                active: private_key.toString(),
                memo: private_key.toString(),
            });
        } catch (error) {
            login_owner_pubkey = PrivateKey.fromSeed(user + 'owner' + password).toPublicKey().toString();
            public_keys = ({
                posting: PrivateKey.fromSeed(user + 'posting' + password).toPublic().toString(),
                active: PrivateKey.fromSeed(user + 'active' + password).toPublic().toString(),
                memo: PrivateKey.fromSeed(user + 'memo' + password).toPublic().toString(),
                owner:login_owner_pubkey
            }); 
        } 
        if (login_owner_pubkey == public_keys.owner && postingpub == public_keys.posting) {
            console.log('Using master key is not allowed');
            isMasterKey = true;
            resolve({success:false, message:"You are using a key linked to your master key, please use ACTIVE/POSTING key."}); 
        }
        if (!isMasterKey) {
            if (postingpub == public_keys.posting || activepub == public_keys.active) {  
                const challengeString = secureRandom.randomBuffer(16).toString('hex');
                if (challengeString) {
                    console.log('challenge string');
                    const signatures = {};
                    const challenge = { token: challengeString };
                    const buf = JSON.stringify(challenge, null, 0);
                    const bufSha = hash.sha256(buf);
        
                    const sign = (role, d) => {
                        console.log('Sign before');
                        if (!d) return;
                        console.log('Sign after');
                        const sig = Signature.signBufferSha256(bufSha, d); 
                        signatures[role] = sig.toHex();
                    };
                    sign('posting', password);
        
                    console.log('Logging in as', user); 
                    saveLoginInfo({user:user,password:password}, false, true);
                    resolve({success:true, message:"Logged in with success.", wif: password})
                }
                resolve({success:false, message:"Something went wrong."});
            }else {
                let message
                if (ownerpub == public_keys.owner) {
                    message = "You are using a key linked to your owner key, please use ACTIVE/POSTING key.";
                    // console.log("This key have owner authorities which is not allowed, please use active/posting key");
                    
                }else if (memopub == public_keys.memo) {
                    message = "You are using a key linked to your memo key, please use ACTIVE/POSTING key.";
                    
                }else {
                    message = "Wrong password."; 
                    
                }
                resolve({success:false, message:message});
            }
        }
      }
      
      
  })
  
}

export function proposalWifVote(voteStatus: boolean, autologin: any, proposalId: number, newWif: string = "") { 
    return new Promise((resolve) => { 
        let data = extractSessionData(autologin); 
        
        let wif = newWif ? dhivePrivateKey.fromString(newWif) : dhivePrivateKey.fromString(data[1]); 
        let username = data[0];
        let ops = [];
        let update_proposal_votes = [
            "update_proposal_votes",
            {
                "voter": username,
                "proposal_ids": [proposalId],
                "approve": voteStatus, 
                "extensions":[]
            }
        ];

        ops.push(update_proposal_votes);

        client.broadcast.sendOperations(ops,wif).then(response => {
            resolve({success:true, result:response}); 
        }).catch(error => {
            resolve({success:false, result:error});
        }) 
    }) 
}

export function witnessWifVote(voteStatus: boolean, autologin: any, witness: string, newWif: string = "") { 
    return new Promise((resolve) => { 
        let data = extractSessionData(autologin); 
        
        let wif = newWif ? dhivePrivateKey.fromString(newWif) : dhivePrivateKey.fromString(data[1]); 
        let username = data[0];
        let ops = [];
        let account_witness_vote = [
            "account_witness_vote",
            {
                "account": username,
                "witness": witness,
                "approve": voteStatus
            }
        ];

        ops.push(account_witness_vote);

        client.broadcast.sendOperations(ops,wif).then(response => {
            resolve({success:true, result:response}); 
        }).catch(error => {
            resolve({success:false, result:error});
        }) 
    }) 
}

export async function postCreateWithWif(post: any, autologin: any, supporting_benef = true) { 
    post = normalizePostMedia(post);
    return new Promise(async (resolve) => { 
        let data = extractSessionData(autologin); 
        
        let wif = dhivePrivateKey.fromString(data[1]); 
        let username = data[0];

        let author = username;
        if (post.author && post.author != username) {
            author = post.author;
        }
        let permlink;
        if (post.permlink) {
            permlink = post.permlink;
        }else {
           try {
                permlink = await createPermlink(post.title, username);
            } catch (error) {
                console.log(error);
                permlink = "speem-" + new Date().getDate() +"-id-" + Math.random().toFixed(4).substring(2);
            } 
        } 
        console.log(post);
        
        let cover = post.cover?post.cover:"";
        let metadata = { 
            tags:post.tags || "", 
            app:'speem/1.1', 
            display_type:post?.display_type || "video",
            video:post.link || "", 
            title:post.title || "", 
            category:post.category,
            image:[cover]
        } 
        let ops = [];
        let comment = [
            "comment",
            {
                author:author,
                title:post.title || "",
                body:post.body,
                parent_author:post.parent_author || "",
                parent_permlink:post.category || post.parent_permlink || "steemvideo",
                permlink: permlink,
                json_metadata:JSON.stringify(metadata)
            }
        ]; 
        ops.push(comment); 
        
        if (post.options && (post.options.rewards != "1" || post.options.beneficiaries.length > 0)){
            console.log('Adding options'); 
            let rewards = post.options.rewards;
            let beneficiaries = post.options.beneficiaries;
            if (supporting_benef) {
                const existing = beneficiaries.find(b => b.account === SPEEM_BENEFICIARY_ACCOUNT);
                if (existing) {
                    // Mantener el mayor % entre el actual y 500
                    existing.weight = Math.max(existing.weight, SPEEM_BENEFICIARY*100);
                } else {
                    beneficiaries.push({account: SPEEM_BENEFICIARY_ACCOUNT, weight: SPEEM_BENEFICIARY*100});
                }
            }
            beneficiaries = beneficiaries.sort((a: any, b: any) => 
                a.account.localeCompare(b.account)
            );

            let max_payout;
            if (rewards != 3) max_payout = '1000000.000 SBD';
            else max_payout = '0.000 SBD'; 
            let pct;
            if (rewards == 1 || rewards == 3) pct = 10000;
            if (rewards == 2) pct = 0;
            beneficiaries = beneficiaries.length > 0?`[[0,{"beneficiaries":${JSON.stringify(beneficiaries)}}]]`:`[]`;
            beneficiaries = JSON.parse(beneficiaries);

            let comment_options = ["comment_options",{
                author:username,
                permlink:permlink,
                max_accepted_payout:max_payout,
                allow_votes:true,
                allow_curation_rewards:true,
                percent_steem_dollars:pct, 
                extensions:beneficiaries
            }];

            ops.push(comment_options); 
        } else { 
            if (supporting_benef) {
                let beneficiaries:any = [];
                beneficiaries.push({account:SPEEM_BENEFICIARY_ACCOUNT, weight:SPEEM_BENEFICIARY*100});
                beneficiaries = beneficiaries.length > 0?`[[0,{"beneficiaries":${JSON.stringify(beneficiaries)}}]]`:`[]`;
                beneficiaries = JSON.parse(beneficiaries);
                let rewards = 1;
                let max_payout;
                if (rewards != 3) max_payout = '1000000.000 SBD';
                else max_payout = '0.000 SBD'; 
                let pct;
                if (rewards == 1 || rewards == 3) pct = 10000;
                if (rewards == 2) pct = 0;

                let comment_options = ["comment_options",{
                    author:username,
                    permlink:permlink,
                    max_accepted_payout:max_payout,
                    allow_votes:true,
                    allow_curation_rewards:true,
                    percent_steem_dollars:pct, 
                    extensions:beneficiaries
                }];

                ops.push(comment_options); 
            }
          
        }
        client.broadcast.sendOperations(ops,wif).then(async (response) => {
            resolve({success:true, result:response, permlink:permlink});
            await setTimeout(async () => {
                let msg = await get_post(username, permlink);
                console.log(msg); 
            }, 5000); 
        }).catch(error => {
            resolve({success:false, result:error, permlink:""});
        });
        
    }) 
} 

export function postWifVote(author:string,permlink:string, weight:number, autologin: any) { 
    return new Promise((resolve) => { 
        let data = extractSessionData(autologin); 
        
        let wif = dhivePrivateKey.fromString(data[1]); 
        let username = data[0];
        let ops = [];
        weight = weight*100;
        let post_vote = [
            "vote",
            {
                "voter": username,
                author:author,
                permlink:permlink,
                weight:weight
            }
        ];

        ops.push(post_vote);

        client.broadcast.sendOperations(ops,wif).then(response => {
            resolve({success:true, result:response}); 
        }).catch(error => {
            resolve({success:false, result:error});
        }) 
    }) 
}
export async function commentCreateWithWif(post: any, autologin: any, comment_callback = true) { 
    return new Promise(async (resolve) => { 
        let data = extractSessionData(autologin);
        let wif = dhivePrivateKey.fromString(data[1]); 
        let username = data[0];
        let permlink = "speem-reply-id-" + Math.random().toFixed(8).substring(4); 
        console.log(permlink);  
        let metadata = {  
            app:'speem/1.1'
        }
        let ops = [];
        let comment = [
            "comment",
            {
                author:username,
                title:"",
                body:post.body,
                parent_author:post.parent_author,
                parent_permlink:post.parent_permlink,
                permlink: permlink,
                json_metadata:JSON.stringify(metadata)
            }
        ]; 
        ops.push(comment);

        // if (post.options.rewards != "1" || post.options.beneficiaries.length > 0){
        //     console.log('Adding options'); 
        //     let rewards = post.options.rewards;
        //     let beneficiaries = post.options.beneficiaries;
        //     let max_payout;
        //     if (rewards != 3) max_payout = '1000000.000 SBD';
        //     else max_payout = '0.000 SBD'; 
        //     let pct;
        //     if (rewards == 1 || rewards == 3) pct = 10000;
        //     if (rewards == 2) pct = 0;
        //     beneficiaries = `[[0,{"beneficiaries":${JSON.stringify(beneficiaries)}}]]`;
        //     beneficiaries = JSON.parse(beneficiaries);

        //     let comment_options = ["comment_options",{
        //         author:username,
        //         permlink:permlink,
        //         max_accepted_payout:max_payout,
        //         allow_votes:true,
        //         allow_curation_rewards:true,
        //         percent_steem_dollars:pct, 
        //         extensions:beneficiaries
        //     }];

        //     ops.push(comment_options);
        // } 
        let reply = {}
        
        client.broadcast.sendOperations(ops,wif).then(async (response) => {
            if (comment_callback) {
                reply = await getContent(username, permlink);
            }
            resolve({success:true, result:response, permlink:permlink, reply}); 
        }).catch(error => {
            resolve({success:false, result:error, permlink:""});
        }) 
    }) 
} 
export async function transferWithWif(autologin: any, amount, symbol, to:string, memo, newWif="") { 
    return new Promise(async (resolve) => { 
        let data = extractSessionData(autologin); 
        let wif = newWif ? newWif : data[1];
        // let wif = dhivePrivateKey.fromString(key); 
        let username = data[0]; 
        let ops = [];
        let transfer = [
            "transfer",
            {
                from:username.replace("@", "").toLowerCase(),
                amount:amount.toFixed(3)+" "+symbol,
                to:to.replace("@", "").toLowerCase(),
                memo
            }
        ]; 
        ops.push(transfer);  
        let tx = { operations: ops, extensions: [] };
        steem.broadcast.send(tx, { active: wif }, function (err) {
            if (err) {
                return resolve({ success: false, message: err });
            }

            resolve({
                success: true,
                message: "done!",
                
            });
        });
    }) 
}
export async function transferToSavingsWithWif(autologin: any, amount, symbol, to:string,  newWif="") { 
    return new Promise(async (resolve) => { 
        let data = extractSessionData(autologin); 
        let wif = newWif ? newWif : data[1];
        // let wif = dhivePrivateKey.fromString(key); 
        let username = data[0]; 
        let ops = [];
        let transfer = [
            "transfer_to_savings",
            {
                from:username.replace("@", "").toLowerCase(),
                amount:amount.toFixed(3)+" "+symbol,
                to:to.replace("@", "").toLowerCase(),
                memo:""
            }
        ]; 
        ops.push(transfer);  
        let tx = { operations: ops, extensions: [] };
        steem.broadcast.send(tx, { active: wif }, function (err) {
            if (err) {
                return resolve({ success: false, message: err });
            }

            resolve({
                success: true,
                message: "done!",
                
            });
        });
    }) 
}
export async function withdrawFromSavingsWithWif(autologin: any, amount, symbol, to:string,  newWif="") { 
    return new Promise(async (resolve) => { 
        let data = extractSessionData(autologin); 
        let wif = newWif ? newWif : data[1];
        // let wif = dhivePrivateKey.fromString(key); 
        let username = data[0]; 
        let request_id = Math.floor(
            (Date.now() / 1000) % 4294967295
        );
        let ops = [];
        let transfer = [
            "transfer_from_savings",
            {
                from:username.replace("@", "").toLowerCase(),
                amount:amount.toFixed(3)+" "+symbol,
                to:to.replace("@", "").toLowerCase(),
                request_id,
                memo:""
            }
        ]; 
        ops.push(transfer);  
        let tx = { operations: ops, extensions: [] };
        steem.broadcast.send(tx, { active: wif }, function (err) {
            if (err) {
                return resolve({ success: false, message: err });
            }

            resolve({
                success: true,
                message: "done!",
                
            });
        });
    }) 
}
export async function createProposalWithWif(autologin: any, receiver: string, subject: string, permlink: string, daily_pay: number, start: any, end: any, newWif: string = "") {
    return new Promise(async (resolve) => {
        let data = extractSessionData(autologin);
        let wif = newWif ? newWif : data[1];
        let username = data[0];
        let ops = [];
        let create_proposal = [
            "create_proposal",
            {
                creator: username.replace("@", "").toLowerCase(),
                receiver: receiver.replace("@", "").toLowerCase(),
                start_date: new Date(start).toISOString().split('.')[0], 
                end_date: new Date(end).toISOString().split('.')[0],
                daily_pay: Number(daily_pay).toFixed(3) + " SBD",
                subject: subject,
                permlink: permlink,
                extensions: []
            }
        ];
        ops.push(create_proposal);
        let tx = { operations: ops, extensions: [] };
        steem.broadcast.send(tx, { active: wif }, function (err) {
            if (err) {
                return resolve({ success: false, message: err });
            }
            resolve({
                success: true,
                message: "Proposal created successfully!",
            });
        });
    })
}
export async function cancelWithdrawFromSavingsWithWif(autologin: any, request_id,  newWif="") { 
    return new Promise(async (resolve) => { 
        let data = extractSessionData(autologin); 
        let wif = newWif ? newWif : data[1];
        // let wif = dhivePrivateKey.fromString(key); 
        let username = data[0];  
        let ops = [];
        let transfer = [
            "cancel_transfer_from_savings",
            {
                from:username.replace("@", "").toLowerCase(), 
                request_id
            }
        ]; 
        ops.push(transfer);  
        let tx = { operations: ops, extensions: [] };
        steem.broadcast.send(tx, { active: wif }, function (err) {
            if (err) {
                return resolve({ success: false, message: err });
            }

            resolve({
                success: true,
                message: "done!",
                
            });
        });
    }) 
}
export async function transferToVestingWithWif(autologin: any, amount, symbol, to:string, newWif="") { 
    return new Promise(async (resolve) => { 
        let data = extractSessionData(autologin); 
        let wif = newWif ? newWif : data[1];
        // let wif = dhivePrivateKey.fromString(key); 
        let username = data[0]; 
        let ops = [];
        let transfer = [
            "transfer_to_vesting",
            {
                from:username.replace("@", "").toLowerCase(),
                amount:amount.toFixed(3)+" "+symbol,
                to:to.replace("@", "").toLowerCase()
            }
        ]; 
        ops.push(transfer);  
        let tx = { operations: ops, extensions: [] };
        steem.broadcast.send(tx, { active: wif }, function (err) {
            if (err) {
                return resolve({ success: false, message: err });
            }

            resolve({
                success: true,
                message: "done!",
                
            });
        });
    }) 
}
export async function delegateWithWif(autologin: any, to:string,sp, mvest, newWif="") { 
    return new Promise(async (resolve) => { 
        let data = extractSessionData(autologin); 
        let wif = newWif ? newWif : data[1];
        // let wif = dhivePrivateKey.fromString(key); 
        let username = data[0]; 
        let ops = [];
        let transfer = [
            "delegate_vesting_shares",
            {
                delegator:username.replace("@", "").toLowerCase(),
                vesting_shares:SP2vests(sp,mvest, 6)+" VESTS",
                delegatee:to.replace("@", "").toLowerCase()
            }
        ]; 
        console.log(transfer);
        
        ops.push(transfer);  
        let tx = { operations: ops, extensions: [] };
        steem.broadcast.send(tx, { active: wif }, function (err) {
            if (err) {
                return resolve({ success: false, message: err });
            }

            resolve({
                success: true,
                message: "done!",
                
            });
        });
    }) 
}
export async function powerDownWithWif(autologin: any, sp, mvest, newWif="") { 
    return new Promise(async (resolve) => { 
        let data = extractSessionData(autologin); 
        let wif = newWif ? newWif : data[1];
        // let wif = dhivePrivateKey.fromString(key); 
        let username = data[0]; 
        let ops = [];
        let op = [
            "withdraw_vesting",
            {
                account:username.replace("@", "").toLowerCase(),
                vesting_shares:SP2vests(sp,mvest, 6)+" VESTS"
            }
        ]; 
        console.log(op);
        
        ops.push(op);  
        let tx = { operations: ops, extensions: [] };
        steem.broadcast.send(tx, { active: wif }, function (err) {
            if (err) {
                return resolve({ success: false, message: err });
            }

            resolve({
                success: true,
                message: "done!",
                
            });
        });
    }) 
}
export async function followWithWif(following:any,type:any, autologin: any) { 
    return new Promise(async (resolve) => { 
        let data = extractSessionData(autologin); 
        
        let wif = dhivePrivateKey.fromString(data[1]); 
        let username = data[0]; 
        let ops = [];
        let follow = [
            "custom_json",
            {
                id:"follow",
                required_auths:[],
                required_posting_auths:[username],
                json:JSON.stringify([
                    "follow",
                    {follower:username, following:following, what:[type]}
                ])
            }
        ]; 
        ops.push(follow); 

        client.broadcast.sendOperations(ops,wif).then(response => {
            resolve({success:true, result:response}); 
        }).catch(error => {
            resolve({success:false, result:error });
        }) 
    }) 
}
export async function shareWithWif(autologin: any,author:any,permlink:any ) { 
    return new Promise(async (resolve) => { 
        let data = extractSessionData(autologin); 
        
        let wif = dhivePrivateKey.fromString(data[1]); 
        let account = data[0]; 
        let ops = [];
        let follow = [
            "custom_json",
            {
                id:"follow",
                required_auths:[],
                required_posting_auths:[account],
                json:JSON.stringify([
                    "reblog",
                    {account:account, author:author, permlink:permlink}
                ])
            }
        ]; 
        ops.push(follow); 

        client.broadcast.sendOperations(ops,wif).then(response => {
            resolve({success:true, result:response}); 
        }).catch(error => {
            resolve({success:false, result:error });
        }) 
    }) 
}
export async function markAsReadWithWif(autologin: any, timeNow:any ) { 
    return new Promise(async (resolve) => { 
        let data = extractSessionData(autologin); 
        
        let wif = dhivePrivateKey.fromString(data[1]); 
        let account = data[0]; 
        let ops = [];
        let mark = [
            "custom_json",
            {
                id:"notify",
                required_auths:[],
                required_posting_auths:[account],
                json:JSON.stringify([
                    "setLastRead",
                    {date: timeNow}
                ])
            }
        ]; 
        ops.push(mark); 

        client.broadcast.sendOperations(ops,wif).then(response => {
            resolve({success:true, result:response}); 
        }).catch(error => {
            resolve({success:false, result:error });
        }) 
    }) 
}
export async function subscribeWithWif(autologin: any, community:string, what:string ) { 
    return new Promise(async (resolve) => { 
        let data = extractSessionData(autologin); 
        
        let wif = dhivePrivateKey.fromString(data[1]); 
        let account = data[0]; 
        let ops = [];
        let mark = [
            "custom_json",
            {
                id:"community",
                required_auths:[],
                required_posting_auths:[account],
                json:JSON.stringify([
                    what,
                    {community: community}
                ])
            }
        ]; 
        ops.push(mark); 

        client.broadcast.sendOperations(ops,wif).then(response => {
            resolve({success:true, result:response}); 
        }).catch(error => {
            resolve({success:false, result:error });
        }) 
    }) 
} 
export async function pinWithWif(autologin: any, community:string, what:string, author:string, permlink:string ) { 
    return new Promise(async (resolve) => { 
        let data = extractSessionData(autologin); 
        
        let wif = dhivePrivateKey.fromString(data[1]); 
        let account = data[0]; 
        let ops = [];
        let mark = [
            "custom_json",
            {
                id:"community",
                required_auths:[],
                required_posting_auths:[account],
                json:JSON.stringify([
                    what,
                    {community: community, account:author, permlink}
                ])
            }
        ]; 
        ops.push(mark); 

        client.broadcast.sendOperations(ops,wif).then(response => {
            resolve({success:true, result:response}); 
        }).catch(error => {
            resolve({success:false, result:error });
        }) 
    }) 
} 
export async function muteWithWif(autologin: any, community:string, what:string, author:string, permlink:string ) { 
    return new Promise(async (resolve) => { 
        let data = extractSessionData(autologin); 
        
        let wif = dhivePrivateKey.fromString(data[1]); 
        let account = data[0]; 
        let ops = [];
        let mark = [
            "custom_json",
            {
                id:"community",
                required_auths:[],
                required_posting_auths:[account],
                json:JSON.stringify([
                    what,
                    {community: community, account:author, permlink, notes:what}
                ])
            }
        ]; 
        ops.push(mark); 

        client.broadcast.sendOperations(ops,wif).then(response => {
            resolve({success:true, result:response}); 
        }).catch(error => {
            resolve({success:false, result:error });
        }) 
    }) 
} 

// Wallet functions
export async function claimWithWif(autologin: any, steem, sp, sbd) { 
    return new Promise(async (resolve) => { 
        let data = extractSessionData(autologin); 
        
        let wif = dhivePrivateKey.fromString(data[1]); 
        let account = data[0]; 
        let ops = [];
        let tx = [
            "claim_reward_balance",
            {
                account:account,
                reward_steem:steem,
                reward_sbd:sbd,
                reward_vests:sp
            }
        ]; 
        ops.push(tx); 

        client.broadcast.sendOperations(ops,wif).then(response => {
            resolve({success:true, result:response}); 
        }).catch(error => {
            resolve({success:false, result:error });
        }) 
    }) 
} 


// Account update functions
export  function accountUpdateWithWif(autologin: any, newProfile:any, newWif:any = "") { 
    return new Promise(async (resolve) => { 
        let data = extractSessionData(autologin); 
        
        let wif = newWif?newWif:(data[1]); 
        let username = data[0];
        let ops = []; 

        let account = await steem.api.callAsync('condenser_api.get_accounts', [[username]]);
        account = account[0];
        let currentMetadata = {};
    
        try {
            if (account.posting_json_metadata) {
                currentMetadata = JSON.parse(account.posting_json_metadata).profile;
            }
        } catch (e) {
            console.warn("invalid json, using empty");
            currentMetadata = {};
        }
    
        const updatedMetadata = {
            profile: {
                ...currentMetadata,
                ...newProfile
            } 
        }; 
        ops.push(['account_update2', {
            account: username,
            posting_key: account.posting.key_auths[0][0],
            active_key: account.active.key_auths[0][0],
            owner_key: account.owner.key_auths[0][0], 
            json_metadata: account.json_metadata,
            posting_json_metadata: JSON.stringify(updatedMetadata)
        }]);
    
    
        let tx = {operations: ops, extensions: []};
        
        steem.broadcast.send(tx, {active:wif}, async function (err) {
            if (!err) {
                resolve({success:true, message:"yey"})
            } else {
                console.log(":'(");
                resolve({success:false, message:err});
            }
        });
    }) 
}
export  function createPlaylistWithWif(autologin: any, newPlaylist:any, newWif:any = "") { 
    return new Promise(async (resolve) => { 
        let data = extractSessionData(autologin); 
        
        let wif = newWif?newWif:(data[1]); 
        let username = data[0];
        let ops = []; 

        let account = await steem.api.callAsync('condenser_api.get_accounts', [[username]]);
        account = account[0];
        let currentMetadata = {};
        let playlists = [];
    
        try {
            if (account.json_metadata) {
                currentMetadata = JSON.parse(account.json_metadata);
                playlists = JSON.parse(account.json_metadata).playlists || [];
            }
        } catch (e) {
            console.warn("invalid json, using empty");
            currentMetadata = {};
        }
        const normalizedNewName = newPlaylist.name.trim().toLowerCase();

        const exists = playlists.some((pl:any) =>
        pl?.name?.trim().toLowerCase() === normalizedNewName
        );

        if (exists) {
            return resolve({
                success: false,
                message: "A playlist with this name already exists."
            });
        }

        const idExists = playlists.some((pl:any) => pl.id === newPlaylist.id);

        if (idExists) {
        return resolve({
            success: false,
            message: "Playlist ID already exists"
        });
        } 
        playlists.push(newPlaylist);
        const updatedMetadata = { 
                ...currentMetadata,
                playlists,
                // playlists:[]
        }; 
        ops.push(['account_update2', {
            account: username,
            posting_key: account.posting.key_auths[0][0],
            active_key: account.active.key_auths[0][0],
            owner_key: account.owner.key_auths[0][0], 
            json_metadata: JSON.stringify(updatedMetadata),
            posting_json_metadata: account.posting_json_metadata
        }]);
    
    
        let tx = {operations: ops, extensions: []};
        
        steem.broadcast.send(tx, {active:wif}, async function (err) {
            if (!err) {
                resolve({success:true, message:"yey"})
            } else {
                console.log(":'(");
                resolve({success:false, message:err});
            }
        });
    }) 
}
export function editPlaylistWithWif(
  autologin: any,
  editedPlaylist: any,
  newWif: any = ""
) {
  return new Promise(async (resolve) => {
    try {
      const data = extractSessionData(autologin);
      const wif = newWif ? newWif : data[1];
      const username = data[0];

      const accountRes = await steem.api.callAsync(
        "condenser_api.get_accounts",
        [[username]]
      );
      const account = accountRes[0];

      let currentMetadata: any = {};
      let playlists: any[] = [];

      try {
        if (account.json_metadata) {
          currentMetadata = JSON.parse(account.json_metadata);
          playlists = currentMetadata.playlists || [];
        }
      } catch {
        currentMetadata = {};
        playlists = [];
      }

      const index = playlists.findIndex(
        (pl: any) => pl.id === editedPlaylist.id
      );

      if (index === -1) {
        return resolve({
          success: false,
          message: "Playlist not found"
        });
      }

      // ⬇️ merge limpio (mantiene items si no los mandas)
      playlists[index] = { 
        ...playlists[index], 
        ...editedPlaylist,
        edited_at: editedPlaylist.edited_at
      };

      const updatedMetadata = {
        ...currentMetadata,
        playlists
      };

      const ops = [
        [
          "account_update2",
          {
            account: username,
            posting_key: account.posting.key_auths[0][0],
            active_key: account.active.key_auths[0][0],
            owner_key: account.owner.key_auths[0][0],
            json_metadata: JSON.stringify(updatedMetadata),
            posting_json_metadata: account.posting_json_metadata
          }
        ]
      ];

      steem.broadcast.send(
        { operations: ops, extensions: [] },
        { active: wif },
        (err: any) => {
          if (err) {
            return resolve({ success: false, message: err });
          }

          resolve({
            success: true,
            message: "Playlist updated successfully"
          });
        }
      );
    } catch (err) {
      resolve({ success: false, message: err });
    }
  });
}

export  function addToPlaylistWithWif(autologin: any, playlistId: string, newItem = { author: "", permlink: "" }, newWif:any = "") { 
    return new Promise(async (resolve) => { 
        let data = extractSessionData(autologin); 
        
        let wif = newWif?newWif:(data[1]); 
        let username = data[0];
        let ops = []; 

        let account = await steem.api.callAsync('condenser_api.get_accounts', [[username]]);
        account = account[0];
        let currentMetadata = {};
        let playlists = [];
    
        try {
            if (account.json_metadata) {
                currentMetadata = JSON.parse(account.json_metadata);
                playlists = JSON.parse(account.json_metadata).playlists || [];
            }
        } catch (e) {
            console.warn("invalid json, using empty");
            currentMetadata = {};
        }
        
        const playlistIndex = playlists.findIndex(
            (pl: any) => pl.id === playlistId
        );

        if (playlistIndex === -1) {
            return resolve({
            success: false,
            message: "Playlist not found"
            });
        }

        const playlist = playlists[playlistIndex];

        
        if (!Array.isArray(playlist.items)) {
            playlist.items = [];
        }
        
        const alreadyExists = playlist.items.some(
            (item: any) =>
            item.author === newItem.author &&
            item.permlink === newItem.permlink
        );

        if (alreadyExists) {
            return resolve({
            success: false,
            message: "This item is already in the playlist"
            });
        }
        
        playlist.items.push({
            author: newItem.author,
            permlink: newItem.permlink
        }); 

        playlists[playlistIndex] = playlist;
        const updatedMetadata = {
            ...currentMetadata,
            playlists
        };
        ops.push(['account_update2', {
            account: username,
            posting_key: account.posting.key_auths[0][0],
            active_key: account.active.key_auths[0][0],
            owner_key: account.owner.key_auths[0][0], 
            json_metadata: JSON.stringify(updatedMetadata),
            posting_json_metadata: account.posting_json_metadata
        }]);
    
    
        let tx = {operations: ops, extensions: []};
        
        steem.broadcast.send(tx, {active:wif}, async function (err) {
            if (err) {
                return resolve({ success: false, message: err });
            }

            resolve({
            success: true,
            message: "Item added to playlist",
            playlist
            });
        });
    }) 
}
export function removeFromPlaylistWithWif(
  autologin: any,
  playlistId: string,
  itemToRemove = { author: "", permlink: "" },
  newWif: any = ""
) {
  return new Promise(async (resolve) => {
    let data = extractSessionData(autologin);

    let wif = newWif ? newWif : data[1];
    let username = data[0];
    let ops = [];

    let account = await steem.api.callAsync(
      "condenser_api.get_accounts",
      [[username]]
    );
    account = account[0];

    let currentMetadata: any = {};
    let playlists: any[] = [];

    try {
      if (account.json_metadata) {
        currentMetadata = JSON.parse(account.json_metadata);
        playlists = currentMetadata.playlists || [];
      }
    } catch (e) {
      console.warn("invalid json_metadata, using empty");
      currentMetadata = {};
      playlists = [];
    }

    const playlistIndex = playlists.findIndex(
      (pl: any) => pl.id === playlistId
    );

    if (playlistIndex === -1) {
      return resolve({
        success: false,
        message: "Playlist not found"
      });
    }

    const playlist = playlists[playlistIndex];

    if (!Array.isArray(playlist.items)) {
      playlist.items = [];
    }

    const initialLength = playlist.items.length;

    playlist.items = playlist.items.filter(
      (item: any) =>
        !(
          item.author === itemToRemove.author &&
          item.permlink === itemToRemove.permlink
        )
    );

    if (playlist.items.length === initialLength) {
      return resolve({
        success: false,
        message: "Item not found in playlist"
      });
    }

    playlists[playlistIndex] = playlist;

    const updatedMetadata = {
      ...currentMetadata,
      playlists
    };

    ops.push([
      "account_update2",
      {
        account: username,
        posting_key: account.posting.key_auths[0][0],
        active_key: account.active.key_auths[0][0],
        owner_key: account.owner.key_auths[0][0],
        json_metadata: JSON.stringify(updatedMetadata),
        posting_json_metadata: account.posting_json_metadata
      }
    ]);

    let tx = { operations: ops, extensions: [] };

    steem.broadcast.send(tx, { active: wif }, function (err) {
      if (err) {
        return resolve({ success: false, message: err });
      }

      resolve({
        success: true,
        message: "Item removed from playlist",
        playlist
      });
    });
  });
}

export function getVotingPower (account) { 
    let voting_power  = account.voting_power; 
    let last_vote_time    = new Date(account.last_vote_time + "Z"); 
    let now = new Date();  
    let elapsed_seconds   = (now.getTime() - last_vote_time.getTime()) / 1000; 
    let regenerated_power = Math.round(
      (10000 * elapsed_seconds) / (5 * 24 * 60 * 60)
    ); 
    let current_power = Math.min(voting_power + regenerated_power, 10000); 
    return parseFloat((current_power / 100).toFixed(2));
}
export function vests2SP (vests, per_mvests) {
        //let per_mvests = (await this.getGlobalProps()).per_mvest; 
        return parseFloat((per_mvests * parseFloat(vests) / 1000000).toFixed(3));
}
export function SP2vests (SP, steem_per_mvests, decimals = 3) {
    return (parseFloat(SP) * 1000000 / steem_per_mvests).toFixed(decimals);
}
export function tokenToBalance (object, per_mvest) {
    let precision = 1;
    for (let i = 0; i < object.precision; i++) {
        precision *= 10;
    }
    let value;
    switch (object.nai) {
        case "@@000000013":
            value = (parseFloat(object.amount) / precision).toFixed(3) + " SBD";
            break;
        case "@@000000021":
            value = (parseFloat(object.amount) / precision).toFixed(3) + " STEEM";
            break;
        case "@@000000037":
            value = (vests2SP((parseFloat(object.amount)), per_mvest) / precision).toFixed(3) + " SP";
            break;
    }
    return value;
}
export function getVoteValue(u, votingPower, funds, medianPrice, votingWeight) {
    let val        = 1e4;
    let rewardCalc = parseFloat(funds.reward_balance) / funds.recent_claims;
    let totalvests = (parseInt(u.vesting_shares.replace(" VESTS", "")) + 
                                parseInt(u.received_vesting_shares.replace(" VESTS", "")) - 
                                parseInt(u.delegated_vesting_shares.replace(" VESTS", "")) - 
                                parseInt(u.vesting_withdraw_rate.replace(" VESTS", "")));
    let voteValue; 
    let medianCalc = medianPrice.base.replace(" SBD", "") / medianPrice.quote.replace(" STEEM", ""); 
    voteValue  = (((20000 * totalvests * rewardCalc * medianCalc) * votingPower * votingWeight) / val);
    return voteValue;
}
/**
 * Change account password on the blockchain.
 * Derives all 4 role keys from newMasterPassword, then broadcasts account_update signed with ownerWif.
 */
export async function changePasswordWithWif(
    accountName: string,
    currentOwnerWif: string,
    newMasterPassword: string,
    jsonMetadata: string = ""
): Promise<{ success: boolean; message: string }> {
    return new Promise((resolve) => {
        try {
            const authority = (pub: string) => ({
                weight_threshold: 1,
                account_auths: [],
                key_auths: [[pub, 1]]
            });

            const roles: Array<'owner' | 'active' | 'posting' | 'memo'> = ['owner', 'active', 'posting', 'memo'];
            const newPubs: any = {};
            roles.forEach(role => {
                const priv = PrivateKey.fromSeed(`${accountName}${role}${newMasterPassword}`);
                newPubs[role] = priv.toPublicKey().toString();
            });

            const operation = [
                'account_update',
                {
                    account: accountName,
                    owner: authority(newPubs.owner),
                    active: authority(newPubs.active),
                    posting: authority(newPubs.posting),
                    memo_key: newPubs.memo,
                    json_metadata: jsonMetadata,
                }
            ];

            const tx = { operations: [operation], extensions: [] };
            steem.broadcast.send(tx, { owner: currentOwnerWif }, (err: any) => {
                if (err) {
                    return resolve({ success: false, message: err?.message || String(err) });
                }
                resolve({ success: true, message: "Password changed successfully." });
            });
        } catch (e: any) {
            resolve({ success: false, message: e?.message || String(e) });
        }
    });
}

// ==================== MARKET UTILS ====================

export function parseAmt(amt: any): number {
    if (typeof amt === 'number') return amt;
    const str = typeof amt === 'string' ? amt : amt?.toString() || '0';
    return parseFloat(str.split(' ')[0]) || 0;
}

export function roundNum(val: number, dp: number = 6): number {
    return parseFloat(val.toFixed(dp));
}

export function getExpiration(): string {
    const d = new Date(Date.now() + 27 * 24 * 60 * 60 * 1000);
    return d.toISOString().slice(0, 19);
}

export function fmtDate(dateStr: string): string {
    try {
        const d = new Date(dateStr.endsWith('Z') ? dateStr : dateStr + 'Z');
        return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    } catch { return dateStr; }
}

// ==================== MARKET HELPERS ====================

export async function getMarketTicker(): Promise<any> {
    return new Promise((resolve, reject) => {
        steem.api.getTicker((err: any, result: any) => {
            if (err) reject(err);
            else resolve(result);
        });
    });
}

export async function getOrderBook(limit: number = 20): Promise<any> {
    return new Promise((resolve, reject) => {
        steem.api.getOrderBook(limit, (err: any, result: any) => {
            if (err) reject(err);
            else resolve(result);
        });
    });
}

export async function getRecentTrades(limit: number = 25): Promise<any> {
    return new Promise((resolve, reject) => {
        steem.api.getRecentTrades(limit, (err: any, result: any) => {
            if (err) reject(err);
            else resolve(result);
        });
    });
}

export async function getOpenOrders(username: string): Promise<any> {
    return new Promise((resolve, reject) => {
        steem.api.getOpenOrders(username, (err: any, result: any) => {
            if (err) reject(err);
            else resolve(result);
        });
    });
}

export async function placeLimitOrderWithWif(
    username: string,
    wif: string,
    orderid: number,
    amount_to_sell: string,
    min_to_receive: string,
    fill_or_kill: boolean = false,
    expiration: string = new Date(Date.now() + 27 * 24 * 60 * 60 * 1000).toISOString().slice(0, 19)
): Promise<any> {
    return new Promise((resolve) => {
        steem.broadcast.limitOrderCreate(
            wif,
            username,
            orderid,
            amount_to_sell,
            min_to_receive,
            fill_or_kill,
            expiration,
            (err: any, result: any) => {
                if (err) resolve({ success: false, message: err?.message || String(err) });
                else resolve({ success: true, result });
            }
        );
    });
}

export async function cancelLimitOrderWithWif(
    username: string,
    wif: string,
    orderid: number
): Promise<any> {
    return new Promise((resolve) => {
        steem.broadcast.limitOrderCancel(
            wif,
            username,
            orderid,
            (err: any, result: any) => {
                if (err) resolve({ success: false, message: err?.message || String(err) });
                else resolve({ success: true, result });
            }
        );
    });
}

// ── DATA PROCESSING ────────────────────────────────────────────────────────

export function processTicker(raw: any) {
    if (!raw) return null;
    return {
        latest: parseFloat(raw.latest),
        lowest_ask: parseFloat(raw.lowest_ask),
        highest_bid: parseFloat(raw.highest_bid),
        percent_change: parseFloat(raw.percent_change),
    };
}

export function processOrderbook(raw: any) {
    const process = (side: 'bids' | 'asks') => {
        const parsed: { price: number; steem: number; sbd: number; side: 'bids' | 'asks' }[] = [];
        (raw[side] || []).slice(0, 50).forEach((o: any) => {
            const steem = parseInt(o.steem, 10) / 1000;
            const sbd = parseInt(o.sbd, 10) / 1000;
            if (steem <= 0 || sbd <= 0) return;
            const price = roundNum(sbd / steem, 6);
            parsed.push({ price, steem: roundNum(steem, 3), sbd: roundNum(sbd, 3), side });
        });

        const aggregated: { price: number; steem: number; sbd: number; side: 'bids' | 'asks' }[] = [];
        for (const order of parsed) {
            const priceKey = order.price.toFixed(6);
            const last = aggregated[aggregated.length - 1];
            if (last && last.price.toFixed(6) === priceKey) {
                last.steem = roundNum(last.steem + order.steem, 3);
                last.sbd   = roundNum(last.sbd   + order.sbd,   3);
            } else {
                aggregated.push({ ...order });
            }
        }
        return aggregated.slice(0, 15);
    };
    return { bids: process('bids'), asks: process('asks') };
}

export function processTrades(raw: any[]) {
    return (raw || []).slice(0, 25).map((t: any) => {
        const isBuy = t.current_pays.includes('SBD');
        const steem = isBuy ? parseAmt(t.open_pays) : parseAmt(t.current_pays);
        const sbd = isBuy ? parseAmt(t.current_pays) : parseAmt(t.open_pays);
        const side: 'buy' | 'sell' = isBuy ? 'buy' : 'sell';
        return {
            date: t.date,
            side,
            price: roundNum(sbd / steem, 6),
            steem: roundNum(steem, 3),
            sbd: roundNum(sbd, 3),
        };
    });
}

export function processOpenOrders(raw: any[]) {
    return (raw || []).map((o: any) => {
        const type = o.sell_price.base.includes('STEEM') ? 'ask' : 'bid';
        const steemStr = type === 'ask' ? o.sell_price.base : o.sell_price.quote;
        const sbdStr = type === 'bid' ? o.sell_price.base : o.sell_price.quote;
        const steem = parseAmt(steemStr);
        const sbd = parseAmt(sbdStr);
        const side: 'buy' | 'sell' = type === 'bid' ? 'buy' : 'sell';
        return {
            orderid: o.orderid,
            created: o.created,
            side,
            price: roundNum(sbd / steem, 6),
            steem: roundNum(steem, 3),
            sbd: roundNum(sbd, 3),
        };
    });
}


